<template>
  <div class="count-panel">
    <div
      v-for="card in cards"
      :key="card.id"
      class="card"
    >
      <div class="card-header">
        <h3>{{ card.name }}</h3>
        <i :class="card.icon"></i>
      </div>
      <div class="card-body">
        <div class="count">{{ card.count }}</div>
        <p class="description">{{ card.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotificationInsight } from "@/api";

export default {
  name: "CountPanel",
  props: {
    options: {
      type: Array,
      default: () => [
        {
          id: "activeRules",
          name: "Active Rules",
          icon: "fa fa-check-circle",
          count: 0,
          description: "of 0 total rules",
        },
        {
          id: "pendingAlerts",
          name: "Pending Alerts",
          icon: "fa fa-exclamation-circle",
          count: 0,
          description: "Awaiting acknowledgment",
        },
        {
          id: "escalatedToday",
          name: "Escalated Today",
          icon: "fa fa-arrow-up",
          count: 0,
          description: "Required supervisor attention",
        },
        {
          id: "falseAlerts",
          name: "False Alerts",
          icon: "fa fa-times-circle",
          count: 0,
          description: "This week",
        },
      ],
    },
  },
  data() {
    return {
      metrics: null,
    };
  },
  computed: {
    cards() {
      if (!this.metrics) {
        return this.options;
      }
      const {
        enabledRules = 0,
        totalRules = 0,
        noFeedbackEventCount = 0,
        todayEscalatedEventCount = 0,
        thisWeekFalseFeedbackCount = 0,
      } = this.metrics;
      return [
        {
          id: "activeRules",
          name: "Active Rules",
          icon: "fa fa-check-circle",
          count: enabledRules,
          description: `of ${totalRules} total rules`,
        },
        {
          id: "pendingAlerts",
          name: "Pending Alerts",
          icon: "fa fa-exclamation-circle",
          count: noFeedbackEventCount,
          description: "Awaiting acknowledgment",
        },
        {
          id: "escalatedToday",
          name: "Escalated Today",
          icon: "fa fa-arrow-up",
          count: todayEscalatedEventCount,
          description: "Required supervisor attention",
        },
        {
          id: "falseAlerts",
          name: "False Alerts",
          icon: "fa fa-times-circle",
          count: thisWeekFalseFeedbackCount,
          description: "This week",
        },
      ];
    },
  },
  created() {
    this.fetchNotificationInsight();
  },
  methods: {
    async fetchNotificationInsight() {
      try {
        const data = await getNotificationInsight();
        this.metrics = data || null;
      } catch (error) {
        console.error("Failed to load notification insight", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.count-panel {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 24px;

  .card {
    border: 1px solid #e5e7eb;
    color:white;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      padding-bottom: 8px;

      h3 {
        font-size: 14px;
        font-weight: 500;
        margin: 0;
      }

      i {
        font-size: 16px;
        color: #9ca3af;
      }
    }

    .card-body {
      padding: 16px;
      padding-top: 0;

      .count {
        font-size: 24px;
        font-weight: bold;
      }

      .description {
        font-size: 12px;
        color: #9ca3af;
      }
    }
  }
}
</style>
